'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var PLANS = exports.PLANS = {
  GET_PLANS: {
    LOAD: 'GET_PLANS_LOAD',
    SUCCESS: 'GET_PLANS_SUCCESS',
    FAIL: 'GET_PLANS_FAIL'
  },
  SUBSCRIBE: {
    LOAD: 'SUBSCRIBE_LOAD',
    SUCCESS: 'SUBSCRIBE_SUCCESS',
    FAIL: 'SUBSCRIBE_FAIL'
  }
};

var fetchPlans = exports.fetchPlans = function fetchPlans(payload) {
  return _extends({
    type: PLANS.GET_PLANS.LOAD
  }, payload);
};

var fetchPlansSuccess = exports.fetchPlansSuccess = function fetchPlansSuccess(payload) {
  return {
    type: PLANS.GET_PLANS.SUCCESS,
    payload: payload
  };
};

var fetchPlansFail = exports.fetchPlansFail = function fetchPlansFail(error) {
  return {
    type: PLANS.GET_PLANS.FAIL,
    error: error
  };
};

var subscribePlans = exports.subscribePlans = function subscribePlans(payload) {
  return _extends({
    type: PLANS.SUBSCRIBE.LOAD
  }, payload);
};

var subscribePlansSuccess = exports.subscribePlansSuccess = function subscribePlansSuccess(payload) {
  return {
    type: PLANS.SUBSCRIBE.SUCCESS,
    payload: payload
  };
};

var subscribePlansFail = exports.subscribePlansFail = function subscribePlansFail(error) {
  return {
    type: PLANS.SUBSCRIBE.FAIL,
    error: error
  };
};